import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import DataTable from 'modules/core/components/DataTable'
import i18n from 'modules/core/lib/i18n'

interface Props {
  search: string
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const MyTrainingsDatatable = ({ search, onSearch }: Props) => {
  return (
    <Box gap="s8">
      <DataTable.HeadBar
        disableDefaultActions
        search={{
          value: search,
          onChange: onSearch,
          placeholder: i18n.t('common.search'),
        }}
      />
      <DataTable.Table />
    </Box>
  )
}
